import { jsx as _jsx } from "react/jsx-runtime";
import CheckIcon from '@mui/icons-material/Check';
const ICON_SIZE = '28px';
export const stepperComponentOverrides = {
    MuiStepper: {
        styleOverrides: {
            root: {
                display: 'flex',
                alignItems: 'flex-start',
                margin: 0
            }
        }
    },
    MuiStep: {
        styleOverrides: {
            root: {
                padding: 0,
                margin: 0,
                display: 'flex',
                position: 'relative'
            },
            horizontal: ({ theme, ownerState }) => ({
                marginInline: 4,
                '&:first-of-type': {
                    marginInlineStart: 0,
                    '&.MuiStep-alternativeLabel .MuiStepButton-root::before': {
                        display: 'none'
                    }
                },
                '&:last-of-type': {
                    marginInlineEnd: 0,
                    '&.MuiStep-alternativeLabel .MuiStepButton-root::after': {
                        display: 'none'
                    }
                },
                '&.MuiStep-alternativeLabel .MuiStepButton-root': {
                    '&:before, &:after': {
                        content: '""',
                        position: 'absolute',
                        height: 2,
                        top: 17,
                        zIndex: -1
                    },
                    '&:before': {
                        left: 0,
                        width: '50%',
                        backgroundColor: theme.tokens.FuelColorGray500,
                        ...ownerState.completed || ownerState.active ? {
                            backgroundColor: theme.tokens.FuelColorTextPrimary
                        } : null
                    },
                    '&:after': {
                        width: '50%',
                        right: 0,
                        backgroundColor: theme.tokens.FuelColorGray500,
                        ...ownerState.completed ? {
                            backgroundColor: theme.tokens.FuelColorTextPrimary
                        } : null
                    }
                }
            }),
            vertical: ({ theme, ownerState }) => ({
                '.MuiStepButton-root::before, .MuiStepButton-root::after': {
                    backgroundColor: theme.tokens.FuelColorGray500
                },
                ...ownerState.completed ? {
                    '.MuiStepButton-root::before, .MuiStepButton-root::after': {
                        backgroundColor: theme.tokens.FuelColorTextPrimary
                    }
                } : null,
                '&:has(.MuiStepContent-root)': {
                    display: 'block',
                    borderLeft: 'none',
                    '+ .MuiStepConnector-root': {
                        marginTop: 0
                    }
                },
                '&:first-of-type .MuiStepButton-root:before, &:last-of-type .MuiStepButton-root:after': {
                    display: 'none'
                }
            }),
            alternativeLabel: {
                display: 'flex',
                justifyContent: 'center',
                marginInline: '0'
            }
        }
    },
    MuiStepConnector: {
        styleOverrides: {
            root: {
                pointerEvents: 'none',
                height: ICON_SIZE,
                width: 'auto',
                display: 'flex'
                // margin: '0.25rem 0px'
            },
            horizontal: {
                height: ICON_SIZE,
                width: 'auto',
                alignItems: 'center',
                marginTop: '0.25rem'
            },
            alternativeLabel: ({ ownerState }) => ownerState.orientation === 'horizontal' ? {
                top: '0',
                left: '0',
                right: '0',
                transform: 'translateX(-50%)'
            } : null,
            vertical: ({ theme, ownerState }) => ({
                marginBlock: '0px',
                marginInline: '0.25rem',
                width: ICON_SIZE,
                height: '32px',
                justifyContent: 'center',
                position: 'relative',
                ...ownerState.active || ownerState.completed ? {
                    '+ .MuiStep-root .MuiStepButton-root::before': {
                        backgroundColor: theme.tokens.FuelColorTextPrimary
                    }
                } : null
            }),
            line: ({ theme, ownerState }) => ({
                width: '100%',
                border: 'unset',
                backgroundColor: theme.tokens.FuelColorGray500,
                ...ownerState.active || ownerState.completed ? {
                    backgroundColor: theme.tokens.FuelColorTextPrimary
                } : null,
                ...ownerState.orientation === 'vertical' ? {
                    width: 2
                } : null,
                ...ownerState.orientation === 'horizontal' ? {
                    height: 2,
                    width: '100%'
                } : null
            })
        }
    },
    MuiStepLabel: {
        defaultProps: {
            StepIconComponent: (props) => (_jsx("div", { "data-fuel-step-icon": true, role: 'presentation', children: props.completed ? _jsx(CheckIcon, {}) : props.icon }))
        },
        styleOverrides: {
            root: ({ theme, ownerState }) => ({
                position: 'relative',
                display: 'flex',
                gap: theme.tokens.FuelSpacing1,
                alignItems: ownerState.alternativeLabel ? 'center' : 'start',
                marginTop: 'unset'
            }),
            vertical: ({ theme }) => ({
                gap: theme.tokens.FuelSpacing2,
                padding: 0
            }),
            iconContainer: ({ theme, ownerState }) => ({
                padding: 0,
                '[data-fuel-step-icon]': {
                    height: ICON_SIZE,
                    width: ICON_SIZE,
                    borderBox: 'border-box',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    borderRadius: '50%',
                    outlineWidth: '2px',
                    outlineStyle: 'solid',
                    outlineOffset: '-2px',
                    outlineColor: theme.tokens.FuelColorTextTertiary,
                    backgroundColor: theme.tokens.FuelColorWhite,
                    fontFamily: theme.typography.fontFamily,
                    textAlign: 'center',
                    fontSize: '1.125rem',
                    fontStyle: 'normal',
                    fontWeight: '600',
                    lineHeight: 'normal',
                    color: theme.tokens.FuelColorTextTertiary,
                    ...ownerState.completed ? {
                        outlineColor: 'transparent',
                        backgroundColor: theme.tokens.FuelColorTextSecondary,
                        color: theme.tokens.FuelColorWhite
                    } : null,
                    ...ownerState.active ? {
                        outlineColor: 'transparent',
                        backgroundColor: theme.tokens.FuelColorTextPrimary,
                        color: theme.tokens.FuelColorWhite
                    } : null
                }
            }),
            label: ({ theme, ownerState }) => ({
                display: 'block',
                fontSize: theme.tokens.FuelFontSizeBase,
                marginTop: 0,
                fontWeight: '600 !important', // TODO: better way to do it?
                color: theme.tokens.FuelColorTextTertiary,
                lineHeight: ICON_SIZE,
                ...ownerState.optional ? {
                    marginBottom: '-0.25rem'
                } : null,
                '&.Mui-active': {
                    color: theme.tokens.FuelColorTextPrimary
                },
                '&.Mui-completed': {
                    color: theme.tokens.FuelColorTextSecondary
                },
                '&.MuiStepLabel-alternativeLabel': {
                    marginTop: 0
                }
            }),
            labelContainer: ({ theme, ownerState }) => ({
                textAlign: ownerState.alternativeLabel ? 'center' : 'left',
                ...theme.typography.body2
            })
        }
    },
    MuiStepButton: {
        styleOverrides: {
            root: ({ theme }) => ({
                position: 'relative',
                zIndex: 1,
                gap: 'unset',
                padding: '0.25rem',
                marginInline: 0,
                marginBlock: 0,
                display: 'inline-flex',
                width: 'auto',
                borderRadius: '0.25rem',
                '&:hover': {
                    backgroundColor: theme.tokens.FuelColorBackgroundActionDefaultHovered
                },
                '&:active': {
                    backgroundColor: theme.tokens.FuelColorGray200 // FIXME: mismatch in Figma/React for fuel-color-action-default-pressed
                },
                '&:focus-visible': {
                    backgroundColor: theme.tokens.FuelColorBackgroundActionDefaultHovered,
                    outline: `solid 2px ${theme.tokens.FuelColorFocused}`
                }
            }),
            vertical: ({ theme }) => ({
                '&:before, &:after': {
                    content: '""',
                    position: 'absolute',
                    width: 2,
                    left: 17,
                    backgroundColor: theme.tokens.FuelColorGray500,
                    zIndex: -1
                },
                '&:before': {
                    top: 0,
                    bottom: '28px'
                },
                '&:after': {
                    top: 'calc(28px + 0.25rem)',
                    bottom: '0'
                }
            })
        }
    },
    MuiStepContent: {
        styleOverrides: {
            root: ({ theme }) => ({
                marginLeft: '17px',
                marginTop: '-0.25rem',
                paddingBlock: 0,
                paddingInline: '21px 8px',
                borderLeftWidth: '2px',
                borderLeftColor: theme.tokens.FuelColorGray500,
                '.MuiCollapse-wrapperInner': {
                    paddingBlock: '0.25rem 0'
                }
            })
        }
    }
};
